import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { PrivacyService } from './privacy.service';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';

@Component({
  selector: 'kgr-privacy-menu-item',
  templateUrl: './privacy-menu-item.component.html',
  styleUrl: './privacy-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconDirective],
})
export class PrivacyMenuItemComponent {
  private configService = inject<ConfigService<ICustomerAppsConfig>>(ConfigService<ICustomerAppsConfig>);
  private privacyService = inject(PrivacyService);

  isCustomizedApp = !!this.configService.config.organization;
  privacyUrl = this.isCustomizedApp
    ? this.configService.config.privacyUrl
    : `${this.configService.config.apiPath}${this.configService.config.privacyUrl}`;

  openPrivacyPdf(): void {
    this.privacyService.openPrivacyPdf();
  }
}
